export const CUSTOM_FILTER_PREFIX = "c__" as const;

export const CUSTOM_FILTERS = {
	timePeriod: `${CUSTOM_FILTER_PREFIX}timePeriod`,
	networkType: `${CUSTOM_FILTER_PREFIX}networkType`,
	status: `${CUSTOM_FILTER_PREFIX}status`,
	search: `${CUSTOM_FILTER_PREFIX}search`,
	structureGroupIds: `${CUSTOM_FILTER_PREFIX}structureGroupIds`,
	structureTypesIds: `${CUSTOM_FILTER_PREFIX}structureTypesIds`,
	structureIds: `${CUSTOM_FILTER_PREFIX}structureIds`,
	isMostDownstream: `${CUSTOM_FILTER_PREFIX}isMostDownstream`,
	hasData: `${CUSTOM_FILTER_PREFIX}hasData`,
	isFullyConfiguredForIAndI: `${CUSTOM_FILTER_PREFIX}isFullyConfiguredForIAndI`,
	isActive: `${CUSTOM_FILTER_PREFIX}isActive`,
	eventType: `${CUSTOM_FILTER_PREFIX}eventType`,
	from: `${CUSTOM_FILTER_PREFIX}from`,
	to: `${CUSTOM_FILTER_PREFIX}to`,
	organizationIds: `${CUSTOM_FILTER_PREFIX}organizationIds`,
	roleNames: `${CUSTOM_FILTER_PREFIX}roleNames`,
	alarmType: `${CUSTOM_FILTER_PREFIX}alarmType`,
	enabled: `${CUSTOM_FILTER_PREFIX}enabled`,
	ownAlarms: `${CUSTOM_FILTER_PREFIX}ownAlarms`,
	perspective: `${CUSTOM_FILTER_PREFIX}perspective`,
	propertyHasValue: `${CUSTOM_FILTER_PREFIX}propertyHasValue`,
} as const;

export const LIST_SELECT_PREFIX = "__select_";

export type CustomFilterKey = keyof typeof CUSTOM_FILTERS;
export type CustomFilterId = (typeof CUSTOM_FILTERS)[CustomFilterKey];
